<template>
	<v-expansion-panels v-model="panel" multiple>
		<v-expansion-panel>
			<v-expansion-panel-header>
				{{ $t("Filter") }}
			</v-expansion-panel-header>
			<v-divider></v-divider>
			<v-expansion-panel-content>
				<v-layout row wrap class="py-4">
					<v-flex xs12 md3>
						<date-range-picker
							v-model="filter.range"
							:appendToBody="true"
							:opens="'right'"
							:locale-data="{
								firstDay: 1,
								format: 'dd mmm yyy',
								applyLabel: $t('label.apply'),
								cancelLabel: $t('label.cancel'),
							}"
							:auto-apply="true"
							:ranges="ranges"
							@update="selectedDate = null"
						>
							<template
								v-slot:input="picker"
								style="border: none"
							>
								<v-text-field
									:label="$t('label.date_range')"
									readonly
									:value="
										selectedDate
											? selectedDate
											: moment(picker.startDate) +
											  '~' +
											  moment(picker.endDate)
									"
								></v-text-field>
							</template>
							<template #ranges="ranges">
								<div class="ranges">
									<ul>
										<li
											v-for="(
												range, name
											) in ranges.ranges"
											:key="name"
											@click="
												ranges.clickRange(range);
												selectedDate = name;
											"
										>
											<b>{{ name }}</b
											><br />
											<small class="text-muted">
												{{ range[0].toDateString() }} -
												{{ range[1].toDateString() }}
											</small>
										</li>
									</ul>
								</div>
							</template>
						</date-range-picker>
					</v-flex>
					<v-flex xs12 md3>
						<v-autocomplete
							:items="outlets"
							item-value="id"
							:item-text="'name'"
							:label="$t('label.outlets')"
							v-model="filter.outlet_id"
							clearable
							hide-details
						>
						</v-autocomplete>
					</v-flex>
					<v-flex xs12 md3>
						<v-autocomplete
							:items="customers"
							item-value="id"
							:item-text="'full_display_name'"
							:label="$t('label.customer')"
							v-model="filter.customer_id"
							clearable
							hide-details
						>
						</v-autocomplete>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field
							:label="$t('Phone Number')"
							v-model="filter.phone_number"
							clearable
							hide-details
						></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field
							:label="$t('Code')"
							v-model="filter.code"
							clearable
							hide-details
						></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-select
							v-model="filter.status"
							:items="[
								{ text: $t('label.all'), value: '' },
								{
									text: $t('label.confirmed'),
									value: 'confirmed',
								},
								{
									text: $t('label.canceled'),
									value: 'canceled',
								},
								{
									text: $t('label.denied'),
									value: 'denied',
								},
							]"
							:label="$t('Status')"
							hide-details
							clearable
						></v-select>
					</v-flex>
				</v-layout>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>
<script>
import moment from "moment";
export default {
	props: ["value", "customers", "outlets"],
	data() {
		return {
			panel: [1],
			selectedDate: this.$t("label.today"),
		};
	},
	computed: {
		filter: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},

		ranges() {
			let today = new Date();
			today.setHours(0, 0, 0, 0);

			let tomorrow = new Date();
			tomorrow.setDate(today.getDate() + 1);
			tomorrow.setHours(0, 0, 0, 0);

			let thisWeek = new Date();
			thisWeek.setDate(today.getDate() - today.getDay());
			thisWeek.setHours(0, 0, 0, 0);

			let nextWeek = new Date();
			nextWeek.setDate(tomorrow.getDate() + 7);
			nextWeek.setHours(0, 0, 0, 0);

			return {
				Today: [today, today],
				Tomorrow: [tomorrow, tomorrow],
				"Next 7 days": [tomorrow, nextWeek],
			};
		},
	},
	watch: {
		filter: {
			handler() {
				this.$emit("filter");
			},
			deep: true,
		},
	},
	methods: {
		moment(date) {
			return moment(date).format("DD MMM YYYY");
		},
	},
};
</script>